// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44050":"9ee9ba4d","48200":"9b05b82f","50667":"148834ae","59555":"31d6cfe0","67100":"0388158c","98751":"148834ae"}[chunkId] + ".chunk.css";
};